module.exports = __webpack_public_path__ + "dingbeauty-build/img/checkout-success.ce295c8d.svg";